import { generateRepositoryMethods } from './repository.types.js';
export const prescriptionRepositoryMethods = generateRepositoryMethods({
    getPrescriptionsWithoutRenewalsByYear: {
        callMethod: 'GET',
        endpoint: '/prescriptions/without-renewals-by-year',
    },
    getAllPrescriptionRequests: {
        callMethod: 'GET',
        endpoint: '/prescription-requests/all',
    },
    getAllPrescriptions: {
        callMethod: 'GET',
        endpoint: '/prescriptions/all',
    },
    getExpiredPrescriptions: {
        callMethod: 'GET',
        endpoint: '/prescriptions/expired',
    },
    createPrescriptionRequest: {
        callMethod: 'POST',
        endpoint: '/prescription-requests/create',
    },
    generatePrescriptionRequestPDF: {
        callMethod: 'POST',
        endpoint: '/prescription-requests/pdf',
    },
});
//# sourceMappingURL=prescription.methods.js.map